// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ie-0";